import '../../../App.css'
import { useState, useEffect } from 'react';
import { Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { TfiPencilAlt } from "react-icons/tfi";
import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import Appconfig from '../../../config/config'
import {
    fetchNewsListAsync,
    createNewsAsync,
    updateNewsAsync,
    deleteNewsAsync,
    clearLastOperation
} from '../../../redux/slice/news/newsSlice';
import NewsModal from './components/NewsModal';

function News() {
    const dispatch = useDispatch();
    const { newsList, loading, error, lastOperation } = useSelector(state => state.news);
    const { userdata } = useSelector((state) => state.authSlice);

    const [openNews, setOpenNews] = useState(false);
    const [currentNews, setCurrentNews] = useState(null);


    useEffect(() => {
        if (lastOperation) {
            switch (lastOperation) {
                case 'create':
                    NotificationManager.success('News added successfully', '', 1000);
                    break;
                case 'update':
                    NotificationManager.success('News updated successfully', '', 1000);
                    break;
                case 'delete':
                    NotificationManager.success('News deleted successfully', '', 1000);
                    break;
                default:
                    break;
            }
            dispatch(clearLastOperation());
            setOpenNews(false);
            setCurrentNews(null);
        }
    }, [lastOperation, dispatch]);

    const handleSubmitNews = (newsData) => {
        const payload = {
            site_id: Appconfig.sitecodes,
            message: newsData.message,
            is_active: "Yes",
            is_delete: "No"
        };

        if (currentNews) {
            dispatch(updateNewsAsync({
                newsId: currentNews._id,
                newsData: payload
            })).unwrap();
            dispatch(fetchNewsListAsync({ site_id: Appconfig.sitecodes }));
        } else {
            dispatch(createNewsAsync(payload)).unwrap();
            dispatch(fetchNewsListAsync({ site_id: Appconfig.sitecodes }));
        }
    };

    const handleDeleteNews = (newsId) => {
        dispatch(deleteNewsAsync(newsId));
    };

    const handleEditNews = (record) => {
        setCurrentNews(record);
        setOpenNews(true);
    };

    const columns = [
        {
            title: 'Message Title',
            dataIndex: 'message',
            render: (_, record) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>
                    {record.message}
                </span>
            ),
        },
        {
            title: 'Edit',
            render: (_, record) => (
                <div
                    className='flex items-center gap-x-4 cursor-pointer'
                    onClick={() => handleEditNews(record)}
                >
                    <span className='flex items-center gap-1 text-[#212529]'>
                        <TfiPencilAlt />
                    </span>
                </div>
            )
        },
        {
            title: 'Delete',
            render: (_, record) => (
                <div
                    className='flex items-center gap-x-4'
                    onClick={() => handleDeleteNews(record._id)}
                >
                    <button
                        disabled={loading}
                        className='w-[26px] h-[26px] ml-[12px] text-[0] flex bg-[#f3f3f3] rounded-[6px] border-[1px] border-[solid] border-[#bbbbbb] float-right cursor-pointer items-center justify-center'
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16px" height="16px" viewBox="0 0 26 26">
                            <path fill="currentColor" d="M16.162,0.213H9.838C9.358,0.535,9.005,1.049,8.78,1.821H2.233c-0.191,0-0.32,0.097-0.32,0.29v2.541    c0,0.193,0.129,0.29,0.32,0.322h21.534c0.224-0.032,0.32-0.129,0.32-0.322V2.111c0-0.193-0.097-0.29-0.32-0.29h-6.514    C16.995,1.049,16.643,0.535,16.162,0.213z"></path>
                            <path fill="currentColor" d="M19.725,25.788c1.088-0.453,1.698-1.256,1.795-2.415c0-0.031,0-0.062,0-0.097l1.058-16.694H3.454    l1.027,16.694c0,0.035,0,0.065,0.031,0.097c0.096,1.159,0.674,1.962,1.765,2.415H19.725z"></path>
                        </svg>
                    </button>
                </div>
            )
        },
    ];

    return (
        <>

            <NewsModal
                open={openNews}
                onCancel={() => {
                    setOpenNews(false);
                    setCurrentNews(null);
                }}
                onSubmit={handleSubmitNews}
                currentNews={currentNews}
            />

            <div className='relative min-w-full'>
                <div className='grid grid-cols-12 relative mt-[20px] lg:mt-[15px] px-[15px] lg:px-[30px]'>
                    <div className='col-span-12 lg:mx-auto'>
                        <div className='lg:block w-full lg:w-[40vw]'>
                            <div className='grid grid-cols-12'>
                                <div className='col-span-12 px-[6px] py-[5px] font-bold text-[0.875rem] rounded-[1px] h-[35px] bg-[linear-gradient(#022c43,_#18b0c8)] text-[#ffffff] flex flex-shrink-0 items-center justify-between'>
                                    <h5 className='text-[0.938rem] font-bold mb-0 leading-normal'>News Management</h5>
                                </div>

                                <div className='col-span-12'>
                                    <div className='bg-[#fff] border-[1px] border-[#0000002d]'>
                                        <div className='text-end p-[0.75rem] flex-auto'>
                                            <button
                                                type='button'
                                                className='text-white bg-[linear-gradient(#022c43,_#18b0c8)] text-[.875rem] rounded-[.25rem] px-[10px] mt-[10px] py-[5px]'
                                                onClick={() => setOpenNews(true)}
                                            >
                                                Add Message
                                            </button>
                                        </div>
                                        <div className='p-[0.75rem] flex-auto'>
                                            <Table
                                                columns={columns}
                                                className='downline-list'
                                                bordered
                                                dataSource={newsList}
                                                loading={loading}
                                                pagination={false}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default News;